
/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import { Directive, forwardRef } from '@angular/core';
import {NG_VALIDATORS, AbstractControl, ValidatorFn, Validator, FormControl} from '@angular/forms';


function measurePasswordStrength(p) {
  let _strong = 0;

  let _letters = testLowercase(p) && testUppercase(p);
  let _numbers = testNumbers(p);
  let _symbols = testSymbols(p);

  let _flags = [_letters, _numbers, _symbols];

  let _passedMatches = _flags.filter(function (el) {
    return el === true;
  }).length;

  _strong += 2 * p.length + ((p.length >= 10) ? 1 : 0);
  _strong += _passedMatches * 10;

  // short password
  _strong = (p.length < 6) ? Math.min(_strong, 10) : _strong;

  // other validations
  _strong = (_passedMatches == 1) ? Math.min(_strong, 20) : _strong;
  _strong = (_passedMatches == 2) ? Math.min(_strong, 30) : _strong;
  _strong = (_passedMatches == 3) ? Math.min(_strong, 40) : _strong;

  console.log("_strong=" + _strong);
  return _strong;
}

function testLength(str: string) : boolean {
  return str.length >= 8;
}

function testLowercase(str: string) : boolean {
  return /[a-z]+/.test(str);
}

function testUppercase(str: string) : boolean {
  return /[A-Z]+/.test(str);
}

function testNumbers(str: string) : boolean {
  return /[0-9]+/.test(str);
}

function testSymbols(str: string) : boolean {
  return /[$-/:-?{-~!@"^_`\[\]]/g.test(str);
}

function getErrorForStrength(strength: number) : string {
  if (strength <=10 ) {
    // console.log("Pffffft.  Pathetic.");
    return 'danger';
  } else if (strength <= 20) {
    // console.log("You are weak.");
    return 'warning-danger';
  } else if (strength <= 30) {
    // console.log("Meh.  You can do better.");
    return 'warning-unsafe';
  } else if (strength < 40){
    // console.log("See?  Was that so hard?");
    return 'warning-safe';
  } else {
    return null;
  }
}

// validation function
function getPasswordStrengthFactory() : ValidatorFn {
  return (c: AbstractControl) => {

    let passwordStrength = measurePasswordStrength(c.value);
    console.log("passwordStrength = " + passwordStrength);

    let error: any = {};

    // let strengthError: string = getErrorForStrength(passwordStrength);
    // if (strengthError) {
    //   error[strengthError] = 'Password not strong enough';
    // }
    // if (!testLength(c.value)) {
    //   error['length']
    // }

    // if (!testLowercase(c.value)) {
    //   error['lowercase'] = 'Minimum 1 lowercase character required';
    // }
    // if (!testUppercase(c.value)) {
    //   error['uppercase'] = 'Minimum 1 uppercase character required';
    // }
    // if (!testNumbers(c.value)) {
    //   error['numbers'] = 'Minimum 1 number required';
    // }
    // if (!testSymbols(c.value)) {
    //   error['symbols'] = 'Minimum 1 symbol required';
    // }

    return error;
  }
}


@Directive({
  selector: '[password][formControlName],[password][formControl],[password][ngControl]',
  providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => PasswordStrengthValidator), multi: true }]
})

export class PasswordStrengthValidator implements Validator {
  validator: ValidatorFn;

  constructor() {
    console.debug("Constructing PasswordStrengthValidator.");
    this.validator = getPasswordStrengthFactory();
  }

  validate(c: FormControl) {
    return this.validator(c);
  }

}




// WEBPACK FOOTER //
// ./src/components/password-strength-bar/password-strength-validator.ts